export default "__VITE_ASSET__BfjCk1Gp__"